import { lazy, Suspense } from 'react';
import { useMeContext } from '../api/me-provider.js';
import { LessonsRoute } from './lessons-route.js';
import { WaitNote } from '../components/wait-note.js';

const CoachLessonsRoute = lazy(() =>
  import('./coach-lessons-route.js').then((module) => ({ default: module.CoachLessonsRoute })),
);

/**
 * The Lessons tab. For an MPC coach it is the lessons they coach (ruled 16
 * October: a coach's own family are booked like anyone, so there is no parent
 * view for a coach); for everyone else, the family's lessons as before. The
 * coach's list is its own download, as the coach's other screens are.
 */
export function LessonsTab() {
  const { state } = useMeContext();
  if (state.status === 'ready' && state.me.is_mpc_coach) {
    return (
      <Suspense fallback={<WaitNote className="empty">Opening…</WaitNote>}>
        <CoachLessonsRoute />
      </Suspense>
    );
  }
  return <LessonsRoute />;
}
